export type MonetizationStatsFilters = {
  store?: string;
  tier?: string;
  from_date?: string;
  to_date?: string;
};

export const cleanFilters = (
  filters: MonetizationStatsFilters
): Record<string, string | number> => {
  const out: Record<string, string | number> = {};
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== null && value !== '') {
      out[key] = value;
    }
  }
  return out;
};
